import PartForm, {
  PartFormData,
} from '@/components/Operational/Inventory/Parts/PartForm';
import { useCreatePart } from '@/core/domain/operational/Parts/Parts.hooks';
import {
  CreatePartRequest,
  Part,
  PartFlag,
} from '@/core/domain/operational/Parts/Parts.types';
import { Form, Modal, ModalProps, notification } from 'antd';
import React from 'react';

export interface OnCallbackAddPart {
  onRefresh?: boolean;
  part: Part;
}

interface Props extends ModalProps {
  onCancel: () => void;
  onCallback?: (params: OnCallbackAddPart) => void;
}

const PartSimpliedRegisterModal: React.FC<Props> = (props) => {
  const [form] = Form.useForm<PartFormData>();

  const createMutation = useCreatePart();

  const handleOk = async () => {
    const values = await form.validateFields();

    const obj: CreatePartRequest = {
      ...values,
      flag: PartFlag.newPart,
      imageUrl: values.imageUrl?.length
        ? values.imageUrl[0].response?.filePath
        : undefined,
    };

    const result = await createMutation.mutateAsync(obj);

    notification.success({
      message: 'Sucesso',
      description: 'Peça criada',
    });

    if (props.onCallback) props.onCallback({ onRefresh: true, part: result });

    Modal.confirm({
      title: 'Cadastro de Peça Concluído',
      content: 'Deseja abrir os detalhes da peça em uma nova guia?',
      onOk: () => {
        props.onCancel();
        window.open(`/app/operational/inventory/parts/${result.id}`, '_blank');
      },
      onCancel: () => {
        props.onCancel();
      },
      okText: 'Abrir',
    });
  };

  return (
    <Modal
      title="Cadastrar peça"
      width="90%"
      {...props}
      okText="Cadastrar"
      onOk={handleOk}
      destroyOnClose
      confirmLoading={createMutation.isLoading}
    >
      <PartForm isLoading={false} form={form} isModal />
    </Modal>
  );
};

export default PartSimpliedRegisterModal;
